"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
// @todo consider adding size as a prop to ChipGroup
// which can then be passed down to the child Chip components
// <ChipGroup size="xs">
//    <Chip />
//    <Chip />
// </ChipGroup>
//
exports.ChipGroup = (0, react_1.forwardRef)(({ children }, ref) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { ref: ref, sx: ({ palette }) => ({
            display: "flex",
            // Don't remove the radius if there's
            // only 1 child
            // i.e this scenario =>
            // <ChipGroup>
            //   <Chip />
            // </ChipGroup>
            ...(react_1.Children.count(children) > 0 && {
                [` .${material_1.chipClasses.root}`]: {
                    "&:not(:last-of-type)": {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        borderRight: `2px solid ${palette.white}`,
                    },
                    "&:not(:first-of-type)": {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                    },
                },
            }),
        }), children: children }));
});
